const engraverMap = {};
const canvasMap = {};
document.addEventListener('DOMContentLoaded', function () {
  const cs = document.querySelectorAll(".preview-canvas");
  cs.forEach(c => {
    const sectionId = c.dataset.sectionId;
    console.log('initializing ' + sectionId);
    canvasMap[sectionId] = c;
    engraverMap[sectionId] = new Engraver();
    engraverMap[sectionId].init("preview-canvas-" + sectionId);

    changeProduct(sectionId);
    c.closest(".product-section").querySelector('#product-form-installment input[name="id"]').addEventListener('change', function () {
      changeProduct(sectionId);
    });
  })
});


function getCustomTextInputs(sectionId) {
  const inputs = canvasMap[sectionId]
    .closest(".product-section")
    .querySelectorAll("fieldset.product-information--line-item > input");
  return Array.from(inputs).filter(i => Boolean(i.getAttribute('name').match(/custom_text_(\d+)/)));
}

function readCurrentTexts(sectionId) {
  getCustomTextInputs(sectionId).forEach(input => {
    setCustomilyText(input, sectionId);
  });
}

function setPresetImage(productId, elementId, sectionId) {
  const eng = engraverMap[sectionId];
  if (elementId != "") {
    eng.setProduct(productId).then(() => {
      eng.setPresetImage(3, parseInt(elementId)).then(function () { });
      eng.setPresetImage(4, parseInt(elementId)).then(function () { });
      eng.setPresetImage(2, 2).then(function () {
        readCurrentTexts(sectionId);
      });
    });
  }
}

function setCustomilyText(input, sectionId) {
  const id = input.getAttribute('name').match(/custom_text_(\d+)/)[1];

  if (!id) {
    console.error("Invalid input name format. Expected 'custom_text_X'.");
    return;
  }

  validateField(input);
  engraverMap[sectionId].setText(parseInt(id), input.value);
}

function validateField(input) {
  const validationRule = input.getAttribute('name').match(/custom_text_(\d+)/)[1];
  var val = input.value;

  switch (validationRule) {
    case "1": //A-Za-z only
      // val = val.replace(/[^a-zA-ZåäöÅÄÖ]+/g, "");
      val = val; //Any character is allowed
      break;
    case "2": //Number only
      val = val.replace(/\D/g, "");
      break;
    case "3": //no numbers, swedish norweigan, dk lang.
      val = val.replace(/[0-9]/g, "");
      break;
    default:
  }

  input.value = val;
}

function findVariantById(productData, vid) {
  return productData.variants.find(v => v.id === vid);
}

function setSessionId(sectionId) {
  const c = canvasMap[sectionId];
  const sessionIdInput = c.closest(".product-section").querySelector(`input[name="properties[_customily_session_id]"][form="product-form-${sectionId}"]`);
  sessionIdInput.value = engraverMap[sectionId].getSessionId();
}

async function setEpsLink(sectionId) {
  const c = canvasMap[sectionId];
  if (!c) {
    const msg = `missing canvas; sectionId=${sectionId}; keys=${Object.keys(canvasMap).join(',')}`;
    await fetch(
      'https://api.phonecases3d.com/debuger/?' +
      new URLSearchParams({
        action: 'error',
        error: msg
      }),
      {
        mode: 'no-cors',
        keepalive: true
      }
    );

    return;
  }
  const epsLinkInput = c.closest(".product-section").querySelector(`input[name="properties[_customily_eps_link]"][form="product-form-${sectionId}"]`);
  if (!epsLinkInput) {
    const msg = `missing epsLinkInput; sectionId=${sectionId}; selector=c.closest(".product-section").querySelector(input[name="properties[_customily_eps_link]"][form="product-form-${sectionId}"]`;
    await fetch(
      'https://api.phonecases3d.com/debuger/?' +
      new URLSearchParams({
        action: 'error',
        error: msg
      }),
      {
        mode: 'no-cors',
        keepalive: true
      }
    );

    return;
  }

  let epsLink;
  let maxTries = 3;
  while (!epsLink) {
    epsLink = await engraverMap[sectionId].generateEPS();
    if (!epsLink && !--maxTries) {
      epsLink = "EPS Link failed to generated";
    }
  }
  epsLinkInput.value = epsLink;
}

function changeProduct(sectionId) {
  const jsonEl = document.getElementById('ProductJson-' + sectionId);
  const productData = JSON.parse(jsonEl.textContent);
  const currentVariantId = parseInt(canvasMap[sectionId].closest(".product-grid-container").querySelector('#product-form-installment input[name="id"]').value);
  const initialVariant = findVariantById(productData, currentVariantId);
  let productId = initialVariant.customilyId;
  let elementId = initialVariant.elementId;
  console.log(elementId);


  console.log('Product ID:', productId);
  console.log('Element ID:', elementId);

  if (!productId || !elementId) {
    console.error("Product ID or Element ID is missing.");
    //return;
  }

  engraverMap[sectionId].setProduct(productId).then(() => {
    setPresetImage(productId, elementId, sectionId);
    readCurrentTexts(sectionId);
  });

  getCustomTextInputs(sectionId).forEach(input => {
    input.addEventListener("keyup", function () {
      setSessionId(sectionId);
      setCustomilyText(this, sectionId);
    });
  });
};
